export const triggerAnalytics = (event, payload) => {
  LIFE_CYCLE_EVENT_BUS.trigger(event, payload);
};

export const localizeToProject = ({ assortmentZip, preferredStore, analyticsString, onUpdate = () => {} }) => {
  try {
    if (
      typeof window !== 'undefined'
      && window?.THD_LOCALIZER_AUTO_INIT?.Localizer
      && assortmentZip
      && preferredStore
    ) {
      if (analyticsString) {
        triggerAnalytics(analyticsString, {});
      }
      window.THD_LOCALIZER_AUTO_INIT.Localizer.localize({
        storeId: preferredStore, localizationMethod: 'Project Localization Banner'
      }).then(() => {
        window.THD_LOCALIZER_AUTO_INIT.Localizer.updateDeliveryZipcodeDetailsNoEvent(
          assortmentZip,
          'USER'
        );
        onUpdate();
        setTimeout(() => window.location.reload(), 100);
      });
    }
  } catch (err) {
  // eslint-disable-next-line no-console
    console.error(err);
  }
};